module.exports = {
	"Play": "Pusti",
	"Pause": "Pauza",
	"Current Time": "Trenutno vrijeme",
	"Duration Time": "Vrijeme trajanja",
	"Remaining Time": "Preostalo vrijeme",
	"Stream Type": "Način strimovanja",
	"LIVE": "UŽIVO",
	"Loaded": "Učitan",
	"Progress": "Progres",
	"Fullscreen": "Puni ekran",
	"Non-Fullscreen": "Mali ekran",
	"Mute": "Prigušen",
	"Unmute": "Ne-prigušen",
	"Playback Rate": "Stopa reprodukcije",
	"Subtitles": "Podnaslov",
	"subtitles off": "Podnaslov deaktiviran",
	"Captions": "Titlovi",
	"captions off": "Titlovi deaktivirani",
	"Chapters": "Poglavlja",
	"You aborted the media playback": "Isključili ste reprodukciju videa.",
	"A network error caused the media download to fail part-way.": "Video se prestao preuzimati zbog greške na mreži.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.",
	"No compatible source was found for this media.": "Nije nađen nijedan kompatibilan izvor ovog videa."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/sr.json
// module id = 1594
// module chunks = 2